import { AlertCircle } from "lucide-react";
import { textoDoErro } from "@/api/problema";

/*
 * A faixa de erro em cartão, da lista ou da aba que não carregou.
 *
 * O resto da tela continua: cabeçalho e outras abas seguem, e a aba mostra a faixa
 * (spec `pagina-do-cedente`). Recusa de escrita não vem para cá: ela volta para o
 * campo, ou para o rodapé do modal.
 */
export function FaixaDeErro({ erro }: { erro: unknown }) {
  return (
    <p
      role="alert"
      className="flex items-start gap-2 rounded-cartao border border-falha/40 bg-falha/10 px-4 py-3 text-falha"
    >
      <AlertCircle aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
      {textoDoErro(erro)}
    </p>
  );
}
